import React, { type PropsWithChildren } from 'react';
import FormattedMessageWithEnglishFallback, {
  type StringIdOrUntranslatedEnglishString,
} from '#/shared/components/FormattedMessageWithEnglishFallback';
import * as Styled from './styled';

interface FieldsetProps extends PropsWithChildren {
  /** level of the heading for the group title; this will most commonly be h2 or h3 */
  headingTag: 'h1' | 'h2' | 'h3' | 'h4' | 'h5';
  groupLabel: StringIdOrUntranslatedEnglishString;
  className?: string;
}

/*
 * For more information on why this is set up with duplicate text see:
 * https://adrianroselli.com/2022/07/use-legend-and-fieldset.html
 * tl;dr: the legend element is important for accessibility but a CSS nightmare
 */
export default function Fieldset({
  groupLabel,
  headingTag,
  children,
  className = undefined,
}: FieldsetProps): React.ReactElement {
  return (
    <Styled.Fieldset className={className}>
      <Styled.Legend>
        <Styled.HeadingTag as={headingTag}>
          <FormattedMessageWithEnglishFallback text={groupLabel} />
        </Styled.HeadingTag>
      </Styled.Legend>
      <Styled.VisibleHeading aria-hidden="true">
        <FormattedMessageWithEnglishFallback text={groupLabel} />
      </Styled.VisibleHeading>
      {children}
    </Styled.Fieldset>
  );
}
